import { useEffect, useMemo } from 'react';
import type { SubscriptionCallback } from '@react-admin/ra-realtime';
import { WebSocketService } from '../../../dataProviders/xgacWebSocket';

const CUSTOMER_USER_RELATIONS_TOPIC = 'resource/customer-user-relations';

export const CustomerAccessRequestNotificationsBootstrap = () => {

  const xgacWebSocket = useMemo(() => new WebSocketService(), []);
  const listener = useMemo((): SubscriptionCallback => () => {}, []);

  useEffect(() => {

    xgacWebSocket.subscribe(CUSTOMER_USER_RELATIONS_TOPIC, listener);
    return () => {

      xgacWebSocket.unsubscribe(CUSTOMER_USER_RELATIONS_TOPIC);

    };

  }, [listener, xgacWebSocket]);

  return null;

};
